import React from 'react';
import './LoadingScreen.css';

const LoadingScreen = ({ userRole }) => {
  // Function to format the role for display
  const formatUserRole = (role) => {
    switch(role) {
      case 'admin':
        return 'Administrator';
      case 'officer':
        return 'Officer';
      default:
        return role || 'User';
    }
  };

  const displayRole = formatUserRole(userRole);

  return (
    <div className="loading-screen">
      <div className="police-logo"></div>
      <div className="loading-text">Kanpur Commissionerate POLICE</div>
      <div>Grievance Management System</div>
      <div className="welcome-text">
        Welcome{displayRole ? `, ${displayRole}` : ''}
      </div>
      <div className="user-role">
        {displayRole ? `Loading your ${displayRole.toLowerCase()} dashboard...` : 'Loading your dashboard...'}
      </div>
      <div className="loading-spinner"></div>
    </div>
  );
};

export default LoadingScreen;